import type { DocStatus } from "../contract"

/** Plain status words for an attached document. */
export function docWord(status: DocStatus | undefined): string {
  if (status === "ready") return "Ready"
  if (status === "failed") return "Couldn't read"
  return "Reading"
}
